import {
  faqLearningSourceGroupLines,
  parseFaqLearningSourceGroups,
} from './useAgentConfigurationForm';

const isValidHttpUrl = value => {
  try {
    return ['http:', 'https:'].includes(new URL(value).protocol);
  } catch {
    return false;
  }
};

export const identityValidation = (form, t) => {
  const errors = {
    name: form.name.trim()
      ? ''
      : t('CAPTAIN_EXPERIENCE.SCRIPT.ALERT_ASSISTANT_NAME_REQUIRED'),
    productName: form.productName.trim()
      ? ''
      : t('CAPTAIN_EXPERIENCE.SCRIPT.ALERT_PRODUCT_REQUIRED'),
  };
  let firstInvalid = null;
  if (errors.name) {
    firstInvalid = { fieldId: 'agent-name', message: errors.name };
  } else if (errors.productName) {
    firstInvalid = {
      fieldId: 'agent-product-name',
      message: errors.productName,
    };
  }
  return { errors, firstInvalid };
};

export const publicationValidation = (form, t) => {
  const requiresSchedulingLink =
    form.qualificationMode === 'pre_scheduling_link';
  const rolloutPercent = Number(form.rolloutPercent);
  const errors = {
    preSchedulingLinkUrl:
      !requiresSchedulingLink || isValidHttpUrl(form.preSchedulingLinkUrl)
        ? ''
        : t('CAPTAIN_EXPERIENCE.SCRIPT.ALERT_INVALID_PRE_SCHEDULING_LINK'),
    rolloutPercent:
      Number.isInteger(rolloutPercent) &&
      rolloutPercent >= 0 &&
      rolloutPercent <= 100
        ? ''
        : t('CAPTAIN_EXPERIENCE.SCRIPT.ALERT_INVALID_ROLLOUT_PERCENT'),
  };
  let firstInvalid = null;
  if (errors.preSchedulingLinkUrl) {
    firstInvalid = {
      fieldId: 'agent-pre-scheduling-link',
      message: errors.preSchedulingLinkUrl,
    };
  } else if (errors.rolloutPercent) {
    firstInvalid = {
      fieldId: 'agent-rollout-percent',
      message: errors.rolloutPercent,
    };
  }
  return { errors, firstInvalid };
};

export const faqLearningValidationError = ({
  form,
  authorizedGroups,
  managedQuestionsGroup,
}) => {
  const hasInvalidSourceGroup = faqLearningSourceGroupLines(
    form.faqLearningSourceGroupsText
  ).some(line => {
    const separatorIndex = line.indexOf('|');
    if (separatorIndex <= 0) return true;
    const jid = line.slice(0, separatorIndex).trim();
    const name = line.slice(separatorIndex + 1).trim();
    if (!jid || !name) return true;
    return (
      authorizedGroups.size > 0 &&
      authorizedGroups.get(jid.toLowerCase()) !== name
    );
  });
  if (hasInvalidSourceGroup) {
    return 'CAPTAIN_EXPERIENCE.SCRIPT.ALERT_INVALID_FAQ_SOURCE_GROUPS';
  }

  const questionsGroupJid = form.faqLearningQuestionsGroupJid.trim();
  const sourceGroupJids = parseFaqLearningSourceGroups(
    form.faqLearningSourceGroupsText
  ).map(group => group.jid.toLowerCase());
  if (
    (managedQuestionsGroup && questionsGroupJid !== managedQuestionsGroup) ||
    (questionsGroupJid &&
      sourceGroupJids.includes(questionsGroupJid.toLowerCase()))
  ) {
    return 'CAPTAIN_EXPERIENCE.SCRIPT.ALERT_INVALID_FAQ_QUESTIONS_GROUP';
  }
  return '';
};
